import { useCallback, useEffect, useMemo } from 'react';

import { getRecordKeyFor } from '~/reducers/customerCommunicationReducer';

import fetchCustomScheduleDestinations from '~/actions/customerCommunication/fetchCustomScheduleDestinations';

import { useAppDispatch, useAppSelector } from '../store';

function useCustomScheduleDestinations(brandId: string) {
  const [key, params] = useMemo(() => {
    const params: Parameters<typeof fetchCustomScheduleDestinations> = [brandId];
    return [getRecordKeyFor(...params), params];
  }, [brandId]);

  const dataReq = useAppSelector((state) => state.customerCommunication.customScheduleDestinationsRecords[key]);

  const appDispatch = useAppDispatch();
  const fetchDestinations = useCallback(() => {
    appDispatch(fetchCustomScheduleDestinations(...params));
  }, [appDispatch, params]);

  useEffect(() => {
    fetchDestinations();
  }, [fetchDestinations]);

  return { dataReq, fetchDestinations };
}

export default useCustomScheduleDestinations;
